// @ts-ignore
import { customElement, property } from 'lit/decorators.js';
// @ts-ignore
import componentStyles from './idb-heading-link.css.lit';
// @ts-ignore
import { classMap } from 'lit/directives/class-map.js';
// @ts-ignore
import { html } from 'lit/static-html.js';
// @ts-ignore
import { TemplateResult } from 'lit';
import {OutlineCard} from "../../../base/outline-card/outline-card";

export type BorderType = | 'full' | 'top' | 'bottom';

export type HeadingYMargin =
  | '0px'
  | '4px'
  | '8px'
  | '12px'
  | '20px'
  | '24px'
  | '31px'
  | '56px';

export type AlignType = 'left' | 'center' | 'right';

interface LinkList {
  title: string;
  url: string;
  icon: string;
  variant: string;
}



@customElement('idb-heading-link')
export class IdbHeadingLink extends OutlineCard {
  static readonly styles = [componentStyles];

  /* Heading has link. */
  @property({ type: Boolean, attribute: 'with-link' })
  withLink: boolean = false;

  /* Heading has link. */
  @property({ type: Boolean, attribute: 'with-button' })
  withButton: boolean = false;

  /* Heading slot title has two lines. */
  @property({ type: Boolean, attribute: 'short-title' })
  shortTitle: boolean = false;

  /* Border for the heading. */
  @property({ type: String, attribute: 'border' })
  border: BorderType;

  /* Border color for the heading. */
  @property({ type: String, attribute: 'border-color' })
  borderColor: string;

  /* Margin Style th only affects top and bottom margins. */
  @property({ type: String, reflect: true, attribute: 'margin-size' })
  marginSize: HeadingYMargin;

  @property({ type: String, reflect: true, attribute: 'title' })
  title: string;

  @property({ type: String, reflect: true, attribute: 'link-title' })
  linkTitle: string;

  @property({ type: String, reflect: true, attribute: 'link-uri' })
  linkUri: string;

  @property({ type: String, reflect: true, attribute: 'link-icon' })
  linkIcon: string;

  @property({ type: String, attribute: 'link-variant' })
  linkVariant: string = 'primary';

  @property({ type: String, attribute: 'align' })
  align: AlignType = 'right';

  @property({ type: Array, attribute: 'links' })
  links: LinkList[];

  @property({ type: Array, attribute: 'buttons' })
  buttons: LinkList[];

  @property({ type: Boolean, attribute: 'hide-links' })
  hideLinks: boolean = false;



  render(): TemplateResult {
    const classesWrapper = {
      'idb-heading__wrapper': true,
    };

    const classesTitle = {
      'idb-heading__title': true,
      'idb-margin-xs': (this.links?.length > 0) || (this.buttons?.length > 0),
      'idb-short-title': this.shortTitle,
    };

    return html`
      <section class="${classMap(classesWrapper)}">
        <p class="${classMap(classesTitle)}">${this.title}</p>
        ${this.renderLinks()}
      </section>
    `;
  }


  renderLinks(): TemplateResult {
    if (this.hideLinks) {
      return html``;
    }

    return html`
      ${(this.links?.length > 0) ? this.templateLinkList() : null}
      ${(this.buttons?.length > 0) ? this.templateButtonList() : null}
      ${(this.withLink && this.linkUri) ? this.templateWithLink() : null}
      ${(this.withButton && this.linkUri) ? this.templateWithButton() : null}
    `;
  }


  templateWithButton(): TemplateResult {
    return html`
      <idb-button button-url="${this.linkUri}" icon-right="${this.linkIcon}" button-variant="${this.linkVariant}">${this.linkTitle}</idb-button>
    `;
  }

  templateWithLink(): TemplateResult {
    return html`
      <a class="idb-heading__cta" href="${this.linkUri}" title="${this.linkTitle}">${this.linkTitle}</a>
    `;
  }

  templateLinkList(): TemplateResult {
    return html`
      <ul class="idb-heading__cta-list idb-heading__cta--align-${this.align}">
        ${this.links.map((link) => html`<li>
          <a class="idb-heading__cta" href="${link.url}" title="${link.title}">${link.title}</a>
        </li>`)}
      </ul>
    `;
  }

  templateButtonList(): TemplateResult {
    return html`
      <ul class="idb-heading__cta-list idb-heading__cta--align-${this.align}">
        ${this.buttons.map((link) => html`<li>
          <idb-button
            button-url="${link.url}"
            icon-right="${this.linkIcon}"
            button-variant="${this.linkVariant}"
          >${link.title}</idb-button>
        </li>`)}
      </ul>
    `;
  }
}
